import React from 'react';
import { Text } from '@chakra-ui/react';

export function NoData({ text = 'No data' }: { text?: string }) {
    return <Text color="disabled">{text}</Text>;
}
